/** Nombre de sucursal para filas de incidencia en nómina. */
export function getPayrollIncidentBranchName(record: any): string {
  const name = String(
    record?.schedule?.branch?.name ??
      record?.branch?.name ??
      record?.checkIn?.branch?.name ??
      ""
  ).trim();
  return name || "—";
}
